import React from "react";

const TextAreaInput = props => {
    let inputClassName = props.inputClassName ? "cdx-input " + props.inputClassName : "cdx-input";
    let className = props.className ? "cdx-form-group " + props.className : "cdx-form-group";

    return (<>
        <div className={className}>
            {props.label && <label className="cdx-inpput-label">{props.label}</label>}
            <div className="cdx-input">
                <textarea {...props} className={inputClassName} />
                {props.maxLength && <span className="cdx-char-count">{props.value ? props.value.length : 0}/{props.maxLength}</span>}
            </div>
        </div>
    </>);
};
export default TextAreaInput;